<template lang="pug">
  .component-einvoice-status
    //
    ModalReveal(v-model="openSdiStatus", @input="closeSdiStatus")
      button.button(slot="trigger", @click="open") Aggiorna filename
      .container
        .row
          .column
            label Filename
              input(type="text" v-model="filename")
      ActionButton(:action="getStatus", slot="footer") Update

</template>

<script>
import ModalReveal from '../../../structure/foundation/ModalReveal'
import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
import ActionButton from '../../../structure/ui/ActionButton'
import MaggieHelper from "../../../../maggieHelper";

export default {
  name: 'UpdateEinvoiceFileName',
  components: {ActionButton, ModalReveal},
  data() {
    return {
      filename: null,
      openSdiStatus: false
    }
  },
  methods: {
    closeSdiStatus() {
      this.sdiStatus = null
      this.openSdiStatus = false
    },
    open() {
      this.openSdiStatus = true
    },
    getStatus() {
      return KeplerBackofficeSdk.invoices.select(this.invoice).updateFilename({
        filename: this.filename
      }, (data) => {
        this.openSdiStatus = false
        MaggieHelper.notification('Updated', 'File name updated')
      })
    },
  },
  props: ['invoice']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// UpdateEinvoiceFileName.vue?31f29248